
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, DropZone, FakeDropZone, Topography } from 'components/ui';
import { sendGovtRecordRequest, govtFormReset } from 'store/actions/govtDocument.action'
import { govtDocumentSelector } from 'store/reducers/govtDocument.reducer'
import { PreloaderWrapper } from 'components/containers';
import Alert from 'components/ui/Alert/Alert';
import { GovtId as GovtIdProps } from 'types';
import DeleteButton from "../../assets/images/deletebutton.png"
import path from 'path'
import '../govtIDDocUpload/govtIDDocUpload.scss'

export const GovtIDDocUploadForm = () => {
    const { isSubmitting, error, success } = useSelector(govtDocumentSelector)
    const [govtId, setGovtId] = useState<GovtIdProps>({});
    const [uploadedFile, setUploadedFile] = useState<any | undefined>()
    const [userId, setUserId] = useState<string>('')
    const [rid, setRid] = useState<string>('')
    const [username, setUserName] = useState<string>('')
    const [govUpload, setGovUpload] = useState<string>('')

    const dispatch = useDispatch();
    useEffect(() => {
        const url_string = window.location.href;
        const url = new URL(url_string);
        setUserId(url.searchParams.get('user_id') || '')
        setRid(url.searchParams.get('request_id') || '')
        setUserName(url.searchParams.get('username') || '')
        // dispatch(checkUploadDocument(url.searchParams.get('user_id')))
        setGovUpload(url.searchParams.get('govt_document') || '')
    }, [])
    const handleUpload = (files: File[], key: 'frontFile' | 'backFile') => setGovtId(govtId => ({ ...govtId, [key]: files[0] }))
    // const handleRemove = (key: 'frontFile' | 'backFile') => setGovtId(govtId => ({ ...govtId, [key]: undefined }))
    const handleFileFrontRemove = () => {
        // if (govtId.frontFileId) dispatch(deleteGovtId(govtId.frontFileId))
        setGovtId(govtId => ({ ...govtId, frontFile: undefined }));
      };
    
      const handleFileBackRemove = () => {
        // if (govtId.backFileId) dispatch(deleteGovtId(govtId.backFileId))
        setGovtId(govtId => ({ ...govtId, backFile: undefined }));
      };
    const next = () => {
        if (govtId?.frontFile && govtId?.backFile) {
            let fd = new FormData()
            fd.append('user_id', userId || '')
            fd.append('request_id', rid || '')
            fd.append('frontFile', govtId.frontFile, `${username}_front${path.extname(govtId.frontFile.name)}`)
            fd.append('backFile', govtId.backFile, `${username}_back${path.extname(govtId.backFile.name)}`)
            dispatch(sendGovtRecordRequest(fd))
        }
    };

    if (isSubmitting) return <PreloaderWrapper />
    else if (success) return (
        <div>
            {govUpload ? (
                <div className='row mt-5 p-auto'>
                    <div className='col-12 col-md-9 ml-auto mr-auto mb-5 text-center'>
                        <Alert type='success' className='alert mx-auto'>{success}</Alert>
                    </div>
                <div className='col-12 col-md-5 mb-3 text-center ml-auto'>
                    <a href={process.env.REACT_APP_BASE_API_URL + '/patient'} className='card-wrapper d-block text-dark'>
                        <Topography.H4 className='d-block'>Create an Account</Topography.H4>
                        <div className='mt-3'><span className='fa fa-check text-success'></span> Request additional medical records</div>
                        <div className='mt-2'><span className='fa fa-check text-success'></span> Add dependents</div>
                        <div className='mt-2'><span className='fa fa-check text-success'></span> Upload forms for school, camp, and more.</div>
                        <div className='mt-4'><Button className='w-auto m-auto'>Continue</Button></div>
                    </a>
                </div>
                <div className='col-12 col-md-5 mb-3 text-center mr-auto'>
                    <a href='/requestor/subscription' className='card-wrapper d-block text-dark'>
                        <Topography.H4 className='d-block'>Subscribe & Share</Topography.H4>
                        <div className='mt-3'><span className='fa fa-check text-success'></span> Access your medical records at anytime.</div>
                        <div className='mt-2'><span className='fa fa-check text-success'></span> Easily share your medical records with any provider.</div>
                        <div className='mt-2'><span className='fa fa-check text-success'></span> Unlimited sharing and faxing of your records.</div>
                        <div className='mt-4'><Button className='w-auto m-auto'>Continue</Button></div>
                    </a>
                </div>
        </div>
            ) : (<div className='row patient-upload-success'>
                <div className='col-12 col-md-9 ml-auto mr-auto mb-5 text-center'>
                    <Alert type='success' className='alert mx-auto'>{success}</Alert>
                </div>
                <div className='col-12 col-md-9 ml-auto mr-auto mb-5 text-center'>
                    <p>Please refresh the desktop browser to continue the sign-up process.</p>
                </div>
            </div>)}
        </div>
    )
    return (
        <div className='row'>
            <div className='col-12'>
                <Topography.H3>{`Government ID Upload`}</Topography.H3>
                <p className='description'>To expedite secure record production, this healthcare provider requires a valid government-issued photo ID.<br/>
Upload or have a link texted to your phone where you can upload from your phone and then continue the process.</p>
               
                <div className='row mt-3 mb-5 justify-content-center'>
                    <div className='col-12 col-md-6 mb-5'>
                        <Topography.H4>Front</Topography.H4>
                        {govtId?.frontFile ? (
                           
                           <div className={"idContainer"}>
                             <img src={DeleteButton} className="deleteButton" onClick={() => handleFileFrontRemove()}/>
                             <img src={URL.createObjectURL(govtId?.frontFile)} className={"govtIdFile"} />
                           </div>
                   ): (
                            <DropZone className='inputtext mobile_upload' maxFileCount={1} maxSize={1024 * 1024 * 25} onUpload={files => handleUpload(files, 'frontFile')} selectedFiles={govtId.frontFile ? [govtId.frontFile] : []} filenames={[`${username}_front`]} accept="image/*,.heif, .heic" showEye={true} placeholder={"Click here to upload or Take a Photo"} placeholder2={"Supports PNG, JPG document"} className2={"textsmall"}  />
                        )}
                    </div>
                    <div className='col-12 col-md-6'>
                        <Topography.H4>Back</Topography.H4>
                        {govtId?.backFile ? (
                           
                                <div className={"idContainer"}>
                                  <img src={DeleteButton} className="deleteButton" onClick={() => handleFileBackRemove()}/>
                                  <img src={URL.createObjectURL(govtId?.backFile)} className={"govtIdFile"} />
                                </div>
                        ) : (
                            <DropZone className='inputtext mobile_upload' maxFileCount={1} maxSize={1024 * 1024 * 25} onUpload={files => handleUpload(files, 'backFile')}  selectedFiles={govtId.backFile ? [govtId.backFile] : []} filenames={[`${username}_back`]} accept="image/*,.heif, .heic" showEye={true} placeholder={"Click here to upload or Take a Photo"} placeholder2={"Supports PNG, JPG document"} className2={"textsmall"}  />
                        )}
                    </div>
                </div>
                <div className='row mb-5 justify-content-md-end'>
                    <div className='col-md-2'>
                        <Button className={'ml-auto'} onClick={next} disabled={!govtId?.frontFile || !govtId?.backFile}>Submit</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
